import { inject, Injectable, signal, computed } from '@angular/core';
import { ENTITIES } from '../store/entities.registry';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppStoreService } from '../store/ngrx-signal.store';
import { GET_TRANSLATIONS } from '../modules/system-utilities/utilities-apps/translations/translation.graphql';
import { environment } from '../../environments/environment';
import { BYPASS_TRANSLATIONS_SEED } from './bypass-translations.data';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private readonly store = inject(AppStoreService);

  public currentLang = signal<'en' | 'sw'>('en'); 

  private translationsSignal = toSignal(this.store.entityData$(ENTITIES.TRANSLATIONS), {
    initialValue: [],
  });

  private translationRows = computed(() =>
    environment.BYPASS_LOGIN ? BYPASS_TRANSLATIONS_SEED : this.translationsSignal(),
  );

  private translationMap = computed(() => {
    const data = this.translationRows();
    const lang = this.currentLang();
    const map: Record<string, string> = {};

    if (data) {
      data.forEach((t: any) => {
        const key = t.keyword?.toLowerCase().trim().split(' ').join('-')?.replace('--', '-') ?? '';
        map[key] = t[lang] ?? t.en ?? '';
      });
    }

    return map;
  });


  init(): void {
    const savedLang = localStorage.getItem('lang') as 'en' | 'en';
    const lang = savedLang ?? 'en';
    if (!environment.BYPASS_LOGIN) {
      this.store.query(ENTITIES.TRANSLATIONS, GET_TRANSLATIONS);
    }
    this.setLanguage(lang);
  }

  setLanguage(lang: 'en' | 'sw') {
    if (this.currentLang() === lang) return;

    this.currentLang.set(lang);
    localStorage.setItem('lang', lang);
  }

 
  translate(keyword: string): string {
    const key = keyword?.toLowerCase().trim().split(' ').join('-').replace('--', '-') ?? '';
    return this.translationMap()[key] ?? keyword;
  }


  getLanguageSignal() {
    return this.currentLang;
  }
}
